import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';


export interface ProductBrandUpsertState extends ApiState {
  productBrandId?: string
}

export default requestReducer<ProductBrandUpsertState>('PRODUCTBRAND_UPSERT')
